import {Injectable} from "@angular/core";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: "root"
})
export class LoadingService {
  private loading = new BehaviorSubject<boolean>(false);

  public start(): void {
    this.loading.next(true);
  }

  public stop(): void {
    this.loading.next(false);
  }

  public isLoading(): Observable<boolean> {
    return this.loading.asObservable();
  }
}
